export const SET_APP_STATE = 'SET_APP_STATE';

export const FETCH_INVITE= 'FETCH_INVITE';
export const SET_RESPONSE = 'SET_RESPONSE';